<p-card>
  <div class="row">
    <div class="col-12">
      <!-- Cabecera del diseño aprobado: título + folio en píldora + cartera como botón compacto.
           La banda de cartera de ancho completo se retiró: competía con el título y empujaba las
           pestañas hacia abajo. -->
      <div class="lease-head">
        <h1 class="lease-head__title">Detalle de arrendamiento</h1>
        <!-- El lápiz va DENTRO de la píldora, igual que en el chip de cartera. Suelto al lado, se leía
             como un botón aparte que no se sabía a qué pertenecía. Quien no puede editar —o el folio
             que no admite cambio— ve la píldora estática, sin lápiz. -->
        <ng-container *ngIf="leaseDetailService.data; else folioCargando">
          <button
            type="button"
            class="lease-folio is-editable"
            *ngIf="canEditFolio && isFolioEditable(); else folioEstatico"
            pTooltip="Editar número del folio"
            tooltipPosition="top"
            (click)="openEditFolio()"
          >
            <span>{{ leaseDetailService.data?.folio }}</span>
            <i class="fa-solid fa-pencil lease-folio__edit" aria-hidden="true"></i>
          </button>
          <ng-template #folioEstatico>
            <span class="lease-folio" [pTooltip]="canEditFolio ? 'Este folio no se puede editar' : ''" tooltipPosition="top">{{
              leaseDetailService.data?.folio
            }}</span>
          </ng-template>
        </ng-container>
        <ng-template #folioCargando><p-skeleton height="1.6rem" width="11rem" borderRadius="999px"></p-skeleton></ng-template>

        <p-skeleton *ngIf="!leaseDetailService.data" height="1.7rem" width="13rem" borderRadius="999px"></p-skeleton>

        <!-- Cartera: mismo dato de la banda anterior, ahora del tamaño de un chip. Quien no puede
             asignar la lee igual, sin botón. -->
        <ng-container *ngIf="leaseDetailService.data">
          <ng-container *appIfHasPermission="['leases', 'update']">
            <button
              type="button"
              class="wallet-pill"
              [class.is-empty]="!leaseDetailService.data?.walletId"
              [pTooltip]="
                leaseDetailService.data?.walletId ? 'Cambiar la cartera del arrendamiento' : 'Asignar una cartera al arrendamiento'
              "
              tooltipPosition="top"
              (click)="openAssignWallet()"
            >
              <i class="fa-solid fa-wallet"></i>
              <span class="wallet-pill__label">Cartera</span>
              <span class="wallet-pill__value">{{ leaseDetailService.data?.walletId?.name || 'Sin asignar' }}</span>
              <i class="fa-solid fa-pencil wallet-pill__edit" aria-hidden="true"></i>
            </button>
          </ng-container>
          <span class="wallet-pill is-static" *ngIf="!canAssignWallet" [class.is-empty]="!leaseDetailService.data?.walletId">
            <i class="fa-solid fa-wallet"></i>
            <span class="wallet-pill__label">Cartera</span>
            <span class="wallet-pill__value">{{ leaseDetailService.data?.walletId?.name || 'Sin asignar' }}</span>
          </span>

          <!-- En juicio, en reestructuración o cartera vencida. No es un `status`: el arrendamiento sigue
               activo. EN JUICIO y CARTERA VENCIDA lo sacan de la cartera, y el diálogo lo dice antes de guardar. -->
          <app-lease-situation-pill
            [leaseId]="leaseDetailService.data?._id || leaseDetailService.id"
            [situation]="leaseDetailService.data?.situation"
            [situationSince]="leaseDetailService.data?.situationSince"
            [leaseStatus]="leaseDetailService.data?.status"
            [settlementDate]="leaseDetailService.data?.settlement?.date || null"
            (changed)="leaseDetailService.getLeaseDetail()"
          ></app-lease-situation-pill>

          <!-- Plan v4.3 §9.3 · Preoferta del canal: solo si la hay y quien mira tiene el módulo -->
          <app-preoffer-pill [leaseId]="leaseDetailService.data?._id || leaseDetailService.id"></app-preoffer-pill>
        </ng-container>
      </div>
      <p class="lease-head__sub">En esta sección podrás visualizar y editar a detalle la información del arrendamiento.</p>
    </div>
    <p-toast></p-toast>
  </div>
  <!-- Carga: el expediente no tiene estado intermedio —o hay arrendamiento o no hay nada—, así que
       bajo el subtítulo quedaba una página en blanco. Esto enseña la barra de pestañas y el bloque
       de contenido que vienen. -->
  <div
    class="row lease-skeleton"
    *ngIf="!leaseDetailService.data && !leaseDetailService.loadError"
    aria-busy="true"
    aria-label="Cargando el expediente del arrendamiento"
  >
    <div class="col-12">
      <div class="lease-sk-tabs">
        <p-skeleton
          *ngFor="let t of ['5rem', '4.5rem', '7rem', '6.5rem', '5.5rem', '8rem', '9rem', '5rem']"
          height="1.1rem"
          [width]="t"
        ></p-skeleton>
      </div>
      <div class="lease-sk-body">
        <p-skeleton height="1.2rem" width="14rem"></p-skeleton>
        <div class="lease-sk-grid">
          <div class="lease-sk-field" *ngFor="let f of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
            <p-skeleton height="0.8rem" width="7rem"></p-skeleton>
            <p-skeleton height="0.95rem" width="10rem"></p-skeleton>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Sin expediente y con motivo: el esqueleto tiene que terminar en algo. Se exige `!data` además
       del motivo: si una recarga en segundo plano falla con el expediente ya en pantalla, el aviso y
       el contenido se pintaban juntos y parecía que la página estaba rota. -->
  <div class="lease-error" *ngIf="leaseDetailService.loadError && !leaseDetailService.data">
    <i class="pi pi-exclamation-triangle"></i>
    <h3>No se pudo abrir el arrendamiento</h3>
    <p>{{ leaseDetailService.loadError }}</p>
    <button
      pButton
      type="button"
      label="Volver a Arrendamientos"
      icon="pi pi-arrow-left"
      class="p-button-outlined p-button-sm"
      routerLink="/lease"
    ></button>
  </div>

  <ng-container *ngIf="leaseDetailService.data">
    <div class="row">
      <div class="col-12">
        <p-tabView styleClass="tabview-custom tabview-plain" [activeIndex]="getActiveTabIndex()" (onChange)="onTabChange($event)">
          <p-tabPanel>
            <ng-template pTemplate="header">
              <i class="fa-solid fa-user" aria-hidden="true"></i>
              <span>Cliente</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-customer></app-lease-customer>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <i class="fa-solid fa-file-invoice-dollar" aria-hidden="true"></i>
              <span>Activos</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-active></app-lease-active>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <i class="fa-solid fa-calculator" aria-hidden="true"></i>
              <span>Cotizaciones</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-quotes></app-lease-quotes>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <i class="fa-solid fa-folder-open" aria-hidden="true"></i>
              <span>Documentos</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-documents></app-lease-documents>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <i class="fa-solid fa-brain" aria-hidden="true"></i>
              <span>Algoritmo</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-algorithm></app-lease-algorithm>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <i class="fa-solid fa-scale-balanced" aria-hidden="true"></i>
              <span>Dictamen Legal</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-legal></app-lease-legal>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <i class="fa-solid fa-magnifying-glass-chart" aria-hidden="true"></i>
              <span>Análisis de riesgo</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-analysis></app-lease-analysis>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel *ngIf="isTabVisible('comite')">
            <ng-template pTemplate="header">
              <i class="fa-solid fa-users-viewfinder" aria-hidden="true"></i>
              <span>Comité</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-committee></app-lease-committee>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <i class="fa-solid fa-handshake-simple" aria-hidden="true"></i>
              <span>Negociación</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-negotiation></app-lease-negotiation>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <i class="fa-solid fa-chart-line" aria-hidden="true"></i>
              <span>Círculo de Crédito</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-circle-credit></app-lease-circle-credit>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <i class="fa-solid fa-file-signature" aria-hidden="true"></i>
              <span>Contrato</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-agreement></app-lease-agreement>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel *ngIf="isTabVisible('facturacion')">
            <ng-template pTemplate="header">
              <i class="fa-solid fa-file-invoice" aria-hidden="true"></i>
              <span>Facturación</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-billing></app-lease-billing>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">
              <i class="fa-solid fa-money-bill" aria-hidden="true"></i>
              <span>Pago inicial</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-start-payment></app-lease-start-payment>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel *ngIf="isTabVisible('adquisicion-activo')">
            <ng-template pTemplate="header">
              <i class="fa-solid fa-credit-card" aria-hidden="true"></i>
              <span>Adquisicion de activo</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-asset-acquisition></app-lease-asset-acquisition>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel *ngIf="isTabVisible('entrega')">
            <ng-template pTemplate="header">
              <i class="fa-solid fa-hands-holding" aria-hidden="true"></i>
              <span>Entrega</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-release></app-lease-release>
            </ng-template>
          </p-tabPanel>
          <!-- <p-tabPanel *ngIf="leaseDetailService.data?.status !== 'Pendiente'">
          <ng-template pTemplate="header">
            <i class="fa-solid fa-wallet" aria-hidden="true"></i>
            <span>Liquidación</span>
          </ng-template>
          <ng-template pTemplate="content">
            <app-lease-settlement></app-lease-settlement>
          </ng-template>
        </p-tabPanel> -->
          <p-tabPanel *ngIf="isTabVisible('cobranza')">
            <ng-template pTemplate="header">
              <i class="fa-solid fa-receipt" aria-hidden="true"></i>
              <span>Cobranza</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-billing-resume></app-lease-billing-resume>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel *ngIf="isTabVisible('exigibilidad')">
            <ng-template pTemplate="header">
              <i class="fa-solid fa-file-waveform" aria-hidden="true"></i>
              <span>Exigibilidad</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-enforceability></app-lease-enforceability>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel *ngIf="isTabVisible('bitacora')">
            <ng-template pTemplate="header">
              <i class="fa-solid fa-clock-rotate-left" aria-hidden="true"></i>
              <span>Bitácora</span>
            </ng-template>
            <ng-template pTemplate="content">
              <app-lease-activity></app-lease-activity>
            </ng-template>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  </ng-container>
</p-card>
<!-- Asignación de cartera desde el detalle -->
<app-assign-wallet-dialog #assignDialog [leaseId]="leaseDetailService.data?._id" (assigned)="onWalletAssigned()"></app-assign-wallet-dialog>
<!-- Edición del primer número del folio (= oldId) -->
<app-edit-folio-modal
  [visible]="editFolioVisible"
  [folio]="leaseDetailService.data?.folio"
  [loading]="editFolioLoading"
  (onHide)="editFolioVisible = false"
  (onSave)="saveFolio($event)"
></app-edit-folio-modal>
